export default __webpack_public_path__ + "static/ImageandWord-01-aff2b853d4363457a956f8b5fd679719.png";